/**
 * Returns whether billing (self-serve reports, checkout, plans & billing UI)
 * is enabled. Reads the build-time env var PEEK_APP_BILLING_ENABLED.
 *
 * When false the user can still view reports created by admins but cannot
 * create new reports, purchase plans, or access any billing surface.
 */
export const useBillingEnabled = () => {
    return process.env.PEEK_APP_BILLING_ENABLED === "true";
};
